import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../app/hooks'
import { fetchUserScripts } from '../../features/script/scriptThunk'
import { clearScripts } from '../../features/script/scriptSlice'

const useScript = () => {
  const dispatch = useDispatch()

  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const { data: zoneData } = useAppSelector((state) => state.zone)
  const {
    data: scriptData,
    loading,
    error,
  } = useAppSelector((state) => state.script)

  useEffect(() => {
    dispatch(fetchUserScripts())

    return () => {
      dispatch(clearScripts())
    }
  }, [dispatch])

  return {
    script: scriptData?.script || [],
    zoneId: zoneData?.id,
    completion: scriptData?.completion ?? null,
    loading,
    error,
    debugP2,
  }
}
export default useScript
